import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Button, Twemoji, ThemeContext} from '../../common';

export default class Gift extends Component {
  static propTypes = {
    gift: PropTypes.shape({
      name: PropTypes.string.isRequired,
      emoji: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }).isRequired,
    toggleGift: PropTypes.func.isRequired,
    onSendGift: PropTypes.func.isRequired,
    isSelected: PropTypes.bool,
  };

  static defaultProps = {
    isSelected: false,
  };

  toggleGift = () => {
    const {toggleGift, gift} = this.props;
    toggleGift(gift);
  }

  render() {
    const {gift, onSendGift, isSelected} = this.props;
    const giftClasses = classNames(
      'gift',
      {
        gift_selected: isSelected,
      }
    );

    return (
      <ThemeContext.Consumer>
        {theme => (
          <div className={giftClasses} onClick={this.toggleGift}>
            <Twemoji emoji={gift.emoji} className="gift__pic"/>
            <div className="gift__name" style={{color: theme.primaryColor}}>{gift.name}</div>
            <Button text="send now" size="xxs" className="gift__send button_rounded" handler={onSendGift}/>
          </div>
        )}
      </ThemeContext.Consumer>
    );
  }
}
